import { render } from "./headbar.vue?vue&type=template&id=28ac96fc&scoped=true&ts=true"
import script from "./headbar.vue?vue&type=script&lang=ts"
export * from "./headbar.vue?vue&type=script&lang=ts"

import "./headbar.vue?vue&type=style&index=0&id=28ac96fc&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/miyo-prod/ftrc-prd/src/project/fotile-riskctl/code/frontend/mgr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ac96fc"]])

export default __exports__